module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-1200.b7e03284.svg";